// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"AntdTable_checkbox__1p5va"};